const isTestCafeInSessionStorage = () =>
  sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG'

export const isTestcafeEnabled = () =>
  !!import.meta.env.VITE_API_BASE_TESTCAFE_URL && isTestCafeInSessionStorage()
